import { useTranslation } from "react-i18next";
import { type CompanyGig } from "model/Gig";
import {
  DescriptionDetailBlock,
  DescriptionDetailValue,
  SalaryDetailBlock,
} from "./teamPublicDetailsModal.styled";
import {
  DetailBlock,
  DetailLabel,
  DetailValue,
  DetailsRow,
} from "../shiftDetailsModal.styled";

interface TeamPublicDetailsModalDetailsSectionProps {
  readonly gigData: CompanyGig;
  readonly isPublicShift: boolean;
  readonly paymentTypeLabel: string;
  readonly skillsLabel: string;
}

export const TeamPublicDetailsModalDetailsSection: React.FC<
  TeamPublicDetailsModalDetailsSectionProps
> = (props) => {
  const { t } = useTranslation();
  const roleLabel = props.gigData.role?.trim() || "-";
  const amountOfWorkersLabel =
    props.gigData.amountOfWorkers == null
      ? "-"
      : String(props.gigData.amountOfWorkers);
  const descriptionLabel = props.gigData.description?.trim() || "-";
  const salaryRangeLabel =
    props.gigData.minRate == null || props.gigData.maxRate == null
      ? "-"
      : `${props.gigData.minRate} - ${props.gigData.maxRate} kr/h`;

  return (
    <>
      <DetailsRow>
        <DetailBlock>
          <DetailValue>{roleLabel}</DetailValue>
          <DetailLabel>{t("Schedule.GigRole")}</DetailLabel>
        </DetailBlock>
        <DetailBlock>
          <DetailValue>{amountOfWorkersLabel}</DetailValue>
          <DetailLabel>{t("Schedule.GigPeopleCount")}</DetailLabel>
        </DetailBlock>
        {props.isPublicShift && (
          <>
            <DetailBlock>
              <DetailValue>{props.paymentTypeLabel}</DetailValue>
              <DetailLabel>{t("Schedule.GigPaymentType")}</DetailLabel>
            </DetailBlock>
            <SalaryDetailBlock>
              <DetailValue>{salaryRangeLabel}</DetailValue>
              <DetailLabel>{t("Schedule.GigSalarySpan")}</DetailLabel>
            </SalaryDetailBlock>
          </>
        )}
      </DetailsRow>
      <DetailsRow>
        {props.isPublicShift && (
          <DetailBlock>
            <DetailValue>{props.skillsLabel}</DetailValue>
            <DetailLabel>{t("Schedule.GigSkills")}</DetailLabel>
          </DetailBlock>
        )}
        <DescriptionDetailBlock $hasLeadingField={props.isPublicShift}>
          <DescriptionDetailValue>{descriptionLabel}</DescriptionDetailValue>
          <DetailLabel>{t("Schedule.GigDescription")}</DetailLabel>
        </DescriptionDetailBlock>
      </DetailsRow>
    </>
  );
};
